import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

function publicClient() {
  const url = process.env.SUPABASE_URL!;
  const key = process.env.SUPABASE_PUBLISHABLE_KEY!;
  return createClient<Database>(url, key, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
}

const resolveLesson = createServerFn({ method: "GET" })
  .inputValidator((d: { lessonSlug: string }) => d)
  .handler(async ({ data }) => {
    const sb = publicClient();
    const { data: lesson } = await sb
      .from("academy_lessons")
      .select("track_id")
      .eq("slug", data.lessonSlug)
      .eq("published", true)
      .maybeSingle();
    if (!lesson) return null;
    const { data: track } = await sb
      .from("academy_tracks")
      .select("slug")
      .eq("id", lesson.track_id)
      .eq("published", true)
      .maybeSingle();
    return track?.slug ?? null;
  });

export const Route = createFileRoute("/academy/lessons/$lessonSlug")({
  loader: async ({ params }) => {
    const trackSlug = await resolveLesson({ data: { lessonSlug: params.lessonSlug } });
    if (!trackSlug) throw redirect({ to: "/academy" });
    throw redirect({
      to: "/academy/tracks/$trackSlug/lessons/$lessonSlug",
      params: { trackSlug, lessonSlug: params.lessonSlug },
    });
  },
});
